import Checkbox from '@mui/material/Checkbox'
import PropTypes from 'prop-types'
import stylesDomicilio from './AdministrarDomicilios.module.css'
import styles from './Perfil.module.css'

const MAX_CARACTERES = 55

const construirDireccionCompleta = (domicilio) => {
  const { calle, calleAltura, provincia, ciudad } = domicilio
  const nombreCompleto = [calle, calleAltura, provincia, ciudad].filter(Boolean).join(', ')
  if (nombreCompleto.length > MAX_CARACTERES) {
    return `${nombreCompleto.substring(0, MAX_CARACTERES)}...`
  }
  return nombreCompleto
}

const Domicilio = ({
  domicilio,
  seleccionados,
  toggleSeleccionado,
  abrirModal,
  esAdministrarDomicilio,
  eliminarDomicilio,
  puedeSeleccionarPreferidos
}) => {
  const direccionCompleta = construirDireccionCompleta(domicilio)
  const etiqueta =
    domicilio.idUsuarioDomicilio === 0 ? 'Domicilio Principal' : `#${domicilio.idUsuarioDomicilio}`

  return (
    <div className={styles.fieldRow}>
      {esAdministrarDomicilio && puedeSeleccionarPreferidos && (
        <Checkbox
          className={stylesDomicilio.fieldCheckbox}
          name={`domicilioSeleccionado-${domicilio.idUsuarioDomicilio}`}
          checked={Boolean(seleccionados?.includes(domicilio.idUsuarioDomicilio))}
          onChange={() => toggleSeleccionado(domicilio.idUsuarioDomicilio)}
        />
      )}
      <div className={stylesDomicilio.domicilioTexto} title={`${etiqueta} ${direccionCompleta}`}>
        <span className={stylesDomicilio.domicilioEtiqueta}>{etiqueta}</span> {direccionCompleta}
      </div>
      <div className={stylesDomicilio.fieldActions}>
        <button
          type="button"
          className={`${styles.btn} ${styles.btnIcon} ${styles.btnOutlineInfo}`}
          onClick={() => abrirModal(domicilio)}
          title="Ver detalles del domicilio"
        >
          <i className="fa fa-info-circle" aria-hidden="true"></i>
        </button>
        {esAdministrarDomicilio && domicilio.vieneDeEBM && (
          <button
            type="button"
            className={`${styles.btn} ${styles.btnIcon} ${styles.btnOutlineDanger}`}
            onClick={() => eliminarDomicilio(domicilio.tipoDomicilio, domicilio.idUsuarioDomicilio)}
            title="Eliminar domicilio"
          >
            <i className="bi bi-trash"></i>
          </button>
        )}
      </div>
    </div>
  )
}

Domicilio.propTypes = {
  domicilio: PropTypes.shape({
    idUsuarioDomicilio: PropTypes.number.isRequired,
    calle: PropTypes.string.isRequired,
    calleAltura: PropTypes.string,
    provincia: PropTypes.string,
    ciudad: PropTypes.string,
    esPreferido: PropTypes.bool,
    vieneDeEBM: PropTypes.bool,
    tipoDomicilio: PropTypes.string.isRequired
  }).isRequired,
  seleccionados: PropTypes.array,
  toggleSeleccionado: PropTypes.func,
  abrirModal: PropTypes.func.isRequired,
  esAdministrarDomicilio: PropTypes.bool.isRequired,
  eliminarDomicilio: PropTypes.func.isRequired,
  puedeSeleccionarPreferidos: PropTypes.bool.isRequired
}
export default Domicilio
